import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { SolutionSection } from '../components/SolutionSection';
import { OfferSection } from '../components/OfferSection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <main className="w-full min-h-screen bg-navy" data-id="element-266">
      <HeroSection data-id="element-267" />
      <PainSection data-id="element-268" />
      <SolutionSection data-id="element-269" />
      <OfferSection data-id="element-270" />
      <Footer data-id="element-271" />
    </main>;
}